// import { lory } from 'lory.js';
import Swiper from 'swiper/js/swiper';
import { tns } from 'tiny-slider/src/tiny-slider';

export default (function () {
	document.addEventListener("DOMContentLoaded", function () {

		//slider slideshow
		(function () {
			var targetSliders = document.querySelectorAll('.listing_slider_panel--halves .slider--slide');
			var slider = [];
			var index;

			targetSliders.forEach(function (targ, index) {

				slider[index] = new tns({
					container: targ,
					items: 1,
					gutter: 25,
					swipeAngle: 25,
					preventScrollOnTouch: 'auto',
					mouseDrag: true,
					autoplay: true,
					autoplayButtonOutput: true,
					autoplayHoverPause:true,
					autoplayResetOnVisibility:false,
					navPosition: 'bottom',
					controls: false,
					controlsContainer: false,
					responsive: {
						768: {
							items: 2,
						},
					}
				});

				//create listing slider navigation
				(function () {
					//get information about the tiny-slider
					let info = slider[index].getInfo();
					let container = info.container;
					let panel = container.closest('.listing_slider_panel');

					if (panel !== null) {
						try {
							//check if there's a teaser
							let teaser = panel.querySelector('.listing_slider_panel__teaser');

							if (teaser !== null) {


								let nav = document.createElement("ul");
								nav.classList.add('listing_slider_panel__slider_nav');

								teaser.appendChild(nav);
								nav.innerHTML = `
								<li>
									<button class = "fal fa-arrow-left slider_nav__button slider_nav__button--prev" aria-label = "previous slide"></button>
								</li>
								<li>
									<button class = "fal fa-arrow-right slider_nav__button slider_nav__button--next" aria-label = "next slide"></button>
								</li>`;

								//add click listeners for slider
								panel.querySelector('.slider_nav__button--prev').addEventListener('click', function () {
									slider[index].goTo('prev');
								});
								panel.querySelector('.slider_nav__button--next').addEventListener('click', function () {
									slider[index].goTo('next');
								});
							}
						} catch (err) {
							console.warn("Something's...missing.");
						}
					}
				})();
			});
		})();

		//slider slideshow -- thirds

		(function () {
			var targetSliders = document.querySelectorAll('.listing_slider_panel--thirds .slider--slide');
			var slider = [];
			var index;

			targetSliders.forEach(function (targ, index) {

				slider[index] = new tns({
					container: targ,
					items: 1,
					gutter: 25,
					autoplay: true,
					mouseDrag: true,
					swipeAngle: 25,
					preventScrollOnTouch: 'auto',
					autoplayHoverPause: true,
					autoplayButtonOutput: true,
					autoplayResetOnVisibility: false,
					navPosition: 'bottom',
					controls: false,
					controlsContainer: false,
					responsive: {
						960: {
							items: 2,
						},
						1100: {
							items: 3,
						}
					}
				});

				//create listing slider navigation
				(function () {
					//get information about the tiny-slider
					if (slider && slider.length) {
						try {
							let info = slider[index].getInfo();
							let container = info.container;
							let panel = container.closest('.listing_slider_panel');

							if (panel !== null) {
								try {
									//check if there's a teaser
									let teaser = panel.querySelector('.listing_slider_panel__teaser');

									if (teaser !== null) {


										let nav = document.createElement("ul");
										nav.classList.add('listing_slider_panel__slider_nav');

										teaser.appendChild(nav);
										nav.innerHTML = `
								<li>
									<button class = "fal fa-arrow-left slider_nav__button slider_nav__button--prev" aria-label = "previous slide"></button>
								</li>
								<li>
									<button class = "fal fa-arrow-right slider_nav__button slider_nav__button--next" aria-label = "next slide"></button>
								</li>`;

										//add click listeners for slider
										panel.querySelector('.slider_nav__button--prev').addEventListener('click', function () {
											slider[index].goTo('prev');
										});
										panel.querySelector('.slider_nav__button--next').addEventListener('click', function () {
											slider[index].goTo('next');
										});
									}
								} catch (err) {
									console.warn("Something's...missing.");
								}
							}
						} catch (e) {
							console.warn(e);
						}
					}


				})();
			});
		})();

		//fader slideshow
		(function () {
			var targetFaders = document.querySelectorAll('.slider--fade');
			var fader = [];
			var index;

			targetFaders.forEach(function (targ, index) {
				fader[index] = new tns({
					container: targ,
					mode: 'gallery',
					nav: false,
					items: 1,
					autoplay: true,
					swipeAngle: 25,
					preventScrollOnTouch: 'auto',
					mouseDrag: true,
					controls: false,
					autoplayButtonOutput: true,
					autoplayResetOnVisibility: false,
					speed: 3000,
					autoplayHoverPause: true,
				});
			});
		})();
	});
})();